import React from "react";
import { VendorShipmentDetails, VendorAddress } from "src/types/database/vendor";
import { CollapsibleSection } from "src/components/ui/collapsible";
import AddressItem from "./AddressItem";

interface Props {
  shipmentDetails: VendorShipmentDetails;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  onAddressChange: (index: number, field: keyof VendorAddress, value: any) => void;
  addAddress: () => void;
  removeAddress: (index: number) => void;
  setCurrentAddress: (index: number) => void;
  getAddressState: (index: number) => boolean;
  onAddressToggle: (index: number, isOpen: boolean) => void;
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
}

const AddressesSection: React.FC<Props> = ({
  shipmentDetails,
  getFieldErrorMessage,
  onAddressChange,
  addAddress,
  removeAddress,
  setCurrentAddress,
  getAddressState,
  onAddressToggle,
  isOpen,
  onToggle
}) => {
  const addresses = shipmentDetails.addresses || [];

  return (
    <CollapsibleSection
      title={`🏠 Addresses (${addresses.length})`}
      isOpen={isOpen}
      onToggle={(open) => onToggle(open)}
      variant="elevated"
    >
      <div className="p-6">
        <div className="mb-6">
          <button
            type="button"
            className="inline-flex items-center px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            onClick={addAddress}
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Address
          </button>
        </div>

        <div className="space-y-4">
          {addresses.map((address, index) => (
            <AddressItem
              key={index}
              address={address}
              index={index}
              addressesLength={addresses.length}
              getAddressState={getAddressState}
              onToggle={onAddressToggle}
              onRemove={removeAddress}
              onSetCurrent={setCurrentAddress}
              onChange={onAddressChange}
              getFieldErrorMessage={getFieldErrorMessage}
            />
          ))}
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default AddressesSection;
